var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.98292 7.19631C6.19132 7.19631 7.17092 6.21671 7.17092 5.00831C7.17092 3.79991 6.19132 2.82031 4.98292 2.82031C3.77452 2.82031 2.79492 3.79991 2.79492 5.00831C2.79492 6.21671 3.77452 7.19631 4.98292 7.19631Z",
    fill: "#2D2D2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2377 8.85469V20.9937H13.0067V14.9907C13.0067 13.4067 13.3047 11.8727 15.2687 11.8727C17.2057 11.8727 17.2297 13.6837 17.2297 15.0907V20.9947H21.0007V14.3377C21.0007 11.0677 20.2967 8.55469 16.4747 8.55469C14.6397 8.55469 13.4097 9.56169 12.9067 10.5147H12.8557V8.85469H9.2377V8.85469ZM3.0957 8.85469H6.8707V20.9937H3.0957V8.85469Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.36df1c50495c7061a05feb2ca1f7b424.svg";
export { ForwardRef as ReactComponent };